import { useMemo } from 'react';

import { Bean, FieldControllerProps, MoneyPatternType, ValidationRules } from '@dreryk/react-common';
import { MoneyInput, StyledMaxWidth } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServiceDefaultPrice } from './defaultPrice.types';

type MedicalServiceDefaultPriceFieldProps = FieldControllerProps<'defaultPrice', MedicalServiceDefaultPrice | null> & {
   readonly disabled?: boolean;
};

export const MedicalServiceDefaultPriceField = (props: MedicalServiceDefaultPriceFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: props.required,
         maxLength: 150,
      };
   }, [props.required]);

   return (
      <StyledMaxWidth maxWidth={133}>
         <MoneyInput
            testId={props.name}
            label={medicalServiceTranslationKeys.shared.defaultPrice.field.label}
            controller={props.register(props.name, validationRules)}
            defaultValue={props.defaultValue}
            pattern={MoneyPatternType.POSITIVE}
            min={1}
            max={999999.99}
            nowrap
            disabled={props.disabled}
         />
      </StyledMaxWidth>
   );
};
